// extracted by mini-css-extract-plugin
module.exports = {"img-wrap":"_cn6g6"};